import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
//
import { HeaderSimple as Header } from './_common';

// ----------------------------------------------------------------------

export default function RegisterLayout({ children }) {
  const { pathname } = useLocation();
  const isExamSpecificRegistration = /^\/register\/[^/]+\/?$/.test(pathname);

  return (
    <>
      {!isExamSpecificRegistration && <Header />}

      <Container component="main">
        <Stack
          sx={{
            m: 'auto',
            maxWidth: '100%',
            minHeight: '100vh',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}

RegisterLayout.propTypes = {
  children: PropTypes.node,
};